export const metadata = {
  title: "Where is this beautiful futsal court? 🤔",
  date: "2025-05-07",
  excerpt: "Jude Bellingham playing futsal?",
  slug: "where-is-this-beautiful-futsal-court",
content: `
  It's not everyday you notice something futsal related on via traditional marketing channels. 
  
  Just to make sure we are on the same page - I am referring to the Lucozade advert that features Jude Bellingham and friends take on a group of a renovators in a game of futsal. 

  In the advert Jude appears at the court with a group of friends only to discover is it "under construction", what follows is an entertaining sequence of skills accompanied with well fitting music played on a futsal court. The ball appeared to be a football, however, the court markings as well as goals were absolutely those typical to futsal/futbol sala.

  So naturally, having been captivated by this advert I naturally tried to find out where on earth this court was? And to my bemusement I wasn't able to find out anything related to the venue. Realistically the actual location has likely been modified for the purpose of this piece of marketing but even after looking at numerous articles I still could not discern this courts location.

  In a last ditch effort I even grabbed a screenshot from the below video in the hope that ChatGPT or DeepSeek would be able to lend their expertise. The answer? Nothing.

  So for the time being, I guess we are in the dark. That is, unless you've come across this blog post and wish to help. If you do don't hesitiate to reach out: thefutsaldirectory@gmail.com and we'd be glad to put this one to rest for everyone!
`,
youtube: "https://www.youtube.com/embed/JbGwzQY21ow?si=_S9sfbxaNrobrFjZ"
};
  